export default __webpack_public_path__ + "static/media/Karnataka2.48c9648f.png";